/**
 * Returns the correct format to be used as a liquid template string.
 *
 * It will return the format based on the active currency in Shopify.
 * If the currency is GBP, it will not show decimal places.
 * For other currencies, it will show decimal places if the amount is not an integer.
 *
 * @example
 * formatMoneyWithConditionalCents(1234) // returns '<span>${{ amount }}</span>'
 * formatMoneyWithConditionalCents(1000) // returns '<span>${{ amount_no_decimals }}</span>'
 *
 * @param cents The amount in cents.
 * @returns The formatted monetary string.
 */
export function formatMoneyWithConditionalCents(cents: number): string {
  const amount = cents / 100;
  const currencyCode = window.Shopify?.currency?.active || 'USD';

  if (currencyCode === 'GBP') {
    return '<span>£{{ amount_no_decimals }}</span>';
  }

  return Number.isInteger(amount)
    ? '<span>${{ amount_no_decimals }}</span>'
    : '<span>${{ amount }}</span>';
}
